import { useFeatureFlagEnabled } from 'posthog-js/react';
import { useSelector } from 'react-redux';
import { CountryCode } from '~/enums';
import { RootState } from '~/store';

export const useUsesGermanOnlyApp = (): boolean => {
  const { market } = useSelector((state: RootState) => state.intl);
  const isFlagEnabled = useFeatureFlagEnabled('oneqred-app-de');
  return market === CountryCode.DE && !isFlagEnabled;
};
